export enum NotificationParent {
    APPLICATION = 1,
    SUBSCRIPTION = 2,
    REVIEW = 3,
}

export enum NotificationType {
    APPLICATION_NEW = 100,
    APPLICATION_APPROVED = 101,
    APPLICATION_DECLINED = 102,

    SUBSCRIPTION_ACTIVATED = 200,
    SUBSCRIPTION_REFERRAL = 201,
    SUBSCRIPTION_TRANSACTION_FAILED = 202,

    // Review from client to employees. We bind this type with Application entity.
    CLIENT_REVIEW_CREATE = 300,
    // Review from employee to client. We bind this type with Application entity.
    EMPLOYEE_REVIEW_CREATE = 301,
    // We bind this type with Review entity.
    REVIEW_RECEIVED = 302,
}
